import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * 공인중개사 추천 현황 집계
 * - sent: realtor_invitations 문서 수 (내가 추천 발송한 건)
 * - joined: realtors where referrer_id == me, 가입 후 1년 이내
 * - expiring: joined 중 6개월 이내 만료 예정
 * - expired: 1년 경과 (만료/완료)
 */
export const getReferralStats = async (uid) => {
  if (!uid) return { sent: 0, joined: 0, expiring: 0, expired: 0 };

  let sent = 0;
  try {
    const invSnap = await getDocs(query(
      collection(db, 'realtor_invitations'),
      where('realtor_id', '==', uid)
    ));
    sent = invSnap.size;
  } catch (_) {}

  let joined = 0;
  let expiring = 0;
  let expired = 0;
  try {
    const rSnap = await getDocs(query(
      collection(db, 'realtors'),
      where('referrer_id', '==', uid)
    ));
    const now = Date.now();
    const YEAR = 365 * 24 * 60 * 60 * 1000;
    const SIX_MONTH = 180 * 24 * 60 * 60 * 1000;
    rSnap.docs.forEach((d) => {
      const r = d.data();
      const createdRaw = r.createdAt || r.created_at;
      const created = createdRaw?.toDate?.()
        || (createdRaw?.seconds ? new Date(createdRaw.seconds * 1000) : null);
      if (!created) { joined += 1; return; }
      const expiry = created.getTime() + YEAR;
      if (now > expiry) { expired += 1; return; }
      joined += 1;
      if (expiry - now <= SIX_MONTH) expiring += 1;
    });
  } catch (_) {}

  return {
    sent: Math.max(sent, joined + expired),
    joined,
    expiring,
    expired,
  };
};
